import React, { useState, useEffect } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";

import delicon from "../assets/delete.svg";
import update from "../assets/editBlack.svg";
import { useNavigate } from "react-router-dom";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import "./Css/Viewtestimonial.css";

import { Modal } from "react-bootstrap";
import {
  options_search,
  GuestManagementPageText,
} from "./../CommonJquery/WebsiteText";
import {
  handleError,
  computeTodayDate,
  handleIaphabetnumberChange,
  handleAphabetsChange,
  computeplussevendays,
  goBack,
  formatToYYYYMMDD
} from "../CommonJquery/CommonJquery";
import {
  APL_LINK,
  server_post_data,
  delete_website_master_data,
  get_all_testimonial,
} from "../ServiceConnection/serviceconnection.js";
import DatePicker from "react-datepicker";
import { FaRegEye, FaTimes, FaExclamationCircle } from "react-icons/fa";
import { Button } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
function ViewTestimonial() {
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [testimonials, setshowtestimonial] = useState([]);
  const [testimonialsImage, setshowtestimonialImage] = useState("");
  const [searchfilter, setSearchFilter] = useState("");
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [selectedValue, setSelectedValue] = useState("Name");
  const [filteredData, setfilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [modalMessage, setModalMessage] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [showDltModal, setshowDltModal] = useState(false);
  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  };
  const handleSelect = (event) => {
    setSelectedValue(event.target.value);
  };
  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get("", "", flag, call_id);
  }, []);
  const master_data_get = async (startDate, endDate, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", flag);
    fd.append("start_date", formatToYYYYMMDD(startDate));
    fd.append("end_date", formatToYYYYMMDD(endDate));
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_all_testimonial, fd)
      .then((Response) => {
        console.log(Response);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setshowtestimonial(Response.data.message.data);
          setfilteredData(Response.data.message.data);
          setshowtestimonialImage(Response.data.message.image_link);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    const filteredDatashow = testimonials.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };
  //console.log("sfsfssf", filteredData);
  const handleDelete = async (primaryId) => {
    let fd_from = new FormData();
    fd_from.append("id_for_delete", primaryId);
    fd_from.append("flag_for", 5);
    fd_from.append("for_status_final", "d");
    await server_post_data(delete_website_master_data, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get("", "", 1, 0);
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });

    //console.log("Delete testimonial at index:");
  };

  const handleEdit = (index) => {
    navigate(`/Edit_Testimonial/${index}`);
  };

  const handleNavigate = () => {
    navigate("/Add_Testimonial");
  };
  ///Testi Monial msg Show modal
  const handleShowModal = (message) => {
    setModalMessage(message);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleDltCloseModal = () => {
    setshowDltModal(false);
  };
  const handleShowDltModl = (primaryId) => {
    setSelectedId(primaryId);
    setshowDltModal(true);
  };

  const handleDeleteYes = () => {
    if (selectedId) {
      handleDelete(selectedId);
    }
    setshowDltModal(false);
  };
  const handleDateChange = (date) => {
    setStartDate(date);
  };
  return (
    <div className="dashboard ViewTestiDivContr">
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="container-lg"></div>
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <div className="d-flex gap-2 align-items-center">
                  <p className="breadcrumb-item">View Testimonial</p>
                  <img
                    src={GreyArrow}
                    alt="Rapid Car Leasing"
                    style={{ height: "14px" }}
                  />
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
                className="Back_bttn_page"
              >
                Back
              </Button>

            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.Start_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={startDate}
                          onChange={handleDateChange}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />

                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.End_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-4 bottomAlgin">
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <select id="selectFilter" onChange={handleSelect}>
                          {/* {options_search.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))} */}
                          <option value="Name">Name</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-5 col-sm-8 bottomAlgin">
                      <div className="inputDiv2">
                        <img src={Search} alt="Rapid Car Leasing" />
                        <input
                          type="text"
                          id="search_data"
                          onInput={(e) => {
                            if (selectedValue === options_search[0].value) {
                              handleAphabetsChange(e);
                            }
                            // else if (
                            //   selectedValue === options_search[1].value
                            // ) {
                            //   handleEmailChange(e);
                            // } else if (
                            //   selectedValue === options_search[2].value
                            // ) {
                            //   handleAphabetsChange(e);
                            // }
                          }}
                          placeholder={GuestManagementPageText.Search_Guest}
                        />
                        <button
                          type="button"
                          className="btnSearch"
                          onClick={() => search_data()}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                    <div className="addTestno d-flex justify-content-end gap-2 mt-2">
                      <button type="button" onClick={handleNavigate}>
                        Add Testimonial
                      </button>
                      <div

                        style={{ marginRight: "0" }}
                      >
                        <div className="inputDiv2">
                          <label className="labelPointer" htmlFor="selectFilter">
                            <img src={FilterIcon} alt="Rapid Car Leasing" />
                          </label>
                          <input
                            type="text"
                            placeholder={GuestManagementPageText.Guest_Filter}
                            value={searchfilter}
                            onInput={handleIaphabetnumberChange}
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card mb-3" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh294"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col">Name</th>
                              <th scope="col">
                              Image
                              </th>
                              <th scope="col">
                       
                                City
                              </th>
                             
                              <th scope="col">Title</th>
                              <th scope="col">Rating</th>
                              <th scope="col">Message</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredData && filteredData.length > 0 ? (
                              filteredData.map((testimonial, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyName"
                                      style={{
                                        marginLeft:'20px'
                                      }}
                                    >
                                     {index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                    {testimonial.name}
                                    </div>
                                  </td>
                                  <td>
                                    {/* <div className="historyTableRowText height50 historyName">
                                      {option.name}
                                    </div> */}
                                     <div className="guest_incenter shadowOnlyBottom">
                                      <img
                                        src={
                                          APL_LINK +
                                          testimonialsImage +
                                          testimonial.image
                                        }
                                        alt={testimonial.name}
                                        className="guest-image"
                                        style={{ maxWidth: "50px" }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                    {testimonial.city}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                       {testimonial.title}
                                    </div>
                                  </td>
                                  <td>
                                  {testimonial.ratting}
                                  </td>
                                  <td>
                                  <FaRegEye
                                      onClick={() =>
                                        handleShowModal(testimonial.message)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "var(--primary-color)",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </td>

                                  <td>
                                    {/* <div
                                      className="historyActionsBtns height50 mb-2"
                                      style={{ minHeight: "auto" }}
                                    >
                                      <div className="Action_booking_btn">
                                        <Button
                                          className="instructions Add_Instructions"
                                          onClick={() => openEditModal(option)}
                                        >
                                          Edit <Edit size={16} />
                                        </Button>
                                        <Button
                                          className="instructions Add_Instructions"
                                          onClick={() =>
                                            handleEdit(option.primary_id)
                                          }
                                        >
                                          View History{" "}
                                          <Eye
                                            // className="custumer_eye_icon"
                                            size={16}
                                          />
                                        </Button>
                                      </div>
                                    </div> */}

<div className="actioniconstest">
                                      <img
                                        className="del-icon"
                                        src={update}
                                        onClick={() =>
                                          handleEdit(testimonial.primary_id)
                                        }
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                      />
                                      <img
                                        className="del-icon"
                                        src={delicon}
                                        onClick={() =>
                                          handleShowDltModl(
                                            testimonial.primary_id
                                          )
                                        }
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                       
                      </div>
                    </div>
                  </div>
                </div>


{/*                 
                <div className="viewGuest_table">
                  <div className="viewGuest_table_container stickyTableheigh280">
                    <div className="row m-0">
                      <div className="col-md-12">
                        <table className="table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col" style={{ width: "5%" }}>
                                <div className="theadStyle">
                                  <span>S.No</span>
                                </div>
                              </th>
                              <th scope="col" style={{ width: "20%" }}>
                                <div className="theadStyle imgThead">
                                  <span className="fontWeight600">Name</span>
                                </div>
                              </th>
                              <th scope="col" style={{ width: "10%" }}>
                                <div className="theadStyle imgThead">
                                  <span className="fontWeight600">Image</span>
                                </div>
                              </th>
                              <th scope="col" style={{ width: "15%" }}>
                                <div className="theadStyle fontWeight600">City</div>
                              </th>
                              <th scope="col" style={{ width: "15%" }}>
                                <div className="theadStyle fontWeight600">Title</div>
                              </th>
                              <th scope="col" style={{ width: "15%" }}>
                                <div className="theadStyle fontWeight600">Rating</div>
                              </th>
                              <th scope="col" style={{ width: "25%" }}>
                                <div className="theadStyle fontWeight600">Message</div>
                              </th>
                              <th scope="col" style={{ width: "10%" }}>
                                <div className="theadStyle fontWeight600">Action</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="tboday">
                            {filteredData.map((testimonial, index) => (
                              <React.Fragment key={index}>
                                <tr className="tableRow tbodyStyle">
                                  <td className="th1 tabledata">
                                    {" "}
                                    <div className="guest_incenter borderLeftRadius">
                                      {index + 1}
                                    </div>
                                  </td>

                                  <td className="th1 tabledata">
                                    <div className="guest_incenter borderLeftRadius">
                                      {testimonial.name}
                                    </div>
                                  </td>
                                  <td className="tabledata">
                                    <div className="guest_incenter shadowOnlyBottom">
                                      <img
                                        src={
                                          APL_LINK +
                                          testimonialsImage +
                                          testimonial.image
                                        }
                                        alt={testimonial.name}
                                        className="guest-image"
                                        style={{ maxWidth: "50px" }}
                                      />
                                    </div>
                                  </td>
                                  <td className="tabledata">
                                    <div className="guest_incenter shadowOnlyBottom">
                                      {testimonial.city}
                                    </div>
                                  </td>
                                  <td className="tabledata">
                                    <div className="guest_incenter shadowOnlyBottom">
                                      {testimonial.title}
                                    </div>
                                  </td>
                                  <td className="tabledata">
                                    <div className="guest_incenter shadowOnlyBottom">
                                      {testimonial.ratting}
                                    </div>
                                  </td>

                                  <td className="tabledata">
                                    <FaRegEye
                                      onClick={() =>
                                        handleShowModal(testimonial.message)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "var(--primary-color)",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </td>
                                  <td className="tabledata">
                                    <div className="actioniconstest">
                                      <img
                                        className="del-icon"
                                        src={update}
                                        onClick={() =>
                                          handleEdit(testimonial.primary_id)
                                        }
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                      />
                                      <img
                                        className="del-icon"
                                        src={delicon}
                                        onClick={() =>
                                          handleShowDltModl(
                                            testimonial.primary_id
                                          )
                                        }
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                      />
                                    </div>
                                  </td>
                                </tr>
                                <tr
                                  key={`spacer-${index}`}
                                  style={{ height: "1rem" }}
                                ></tr>
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ------testimonial message Modal------------ */}
      <Modal
        className="testMsgModal"
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="closeBtn" onClick={handleCloseModal}>
            <FaTimes className="closeIcn" />
          </div>
          <div className="testiModalMsg">
            <h4>Messages</h4>
            <p>{modalMessage}</p>
          </div>
        </Modal.Body>
      </Modal>
      {/**-------------Delete Modal------------------ */}
      <Modal
        className="testMsgModal"
        show={showDltModal}
        onHide={handleDltCloseModal}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="closeBtn" onClick={handleDltCloseModal}>
            <FaTimes className="closeIcn" />
          </div>
          {/* Icon Section */}
          <div className="text-center my-3">
            <FaExclamationCircle
              className="confirmationIcon"
              size={45}
              color="#f44336"
            />
          </div>
          <div className="confirmAtionDltmsG">
            <p>Are You Sure want to delete</p>
          </div>
          <div className="dltBtttn">
            <button type="button" onClick={handleDeleteYes}>
              Yes
            </button>
            <button
              type="button"
              className="noBttn"
              onClick={handleDltCloseModal}
            >
              No
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ViewTestimonial;
